import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { initAnalytics } from "./lib/analytics";
import { captureSource } from "./lib/attribution";
import { startEngagementWatch } from "./lib/engagement";

// Both of these run before hydration and both have to.
//
// `captureSource` reads `?src=` off the landing URL: the router replaces the
// URL on the first client navigation, so a tag read any later is a tag read
// off the wrong page.
//
// `initAnalytics` is called explicitly rather than imported for its side
// effect, because a bare side-effect import gets tree-shaken when nothing
// consumes the module's exports. That has silently produced zero events twice
// on this estate.
captureSource();
initAnalytics();
// After initAnalytics, because it emits through it. It is separate from the
// two above because it is not a one-shot read: it watches for five seconds of
// visible time plus one interaction, which is what tells a reader apart from a
// prefetch. See lib/engagement.ts for why the gate cannot be read without it.
startEngagementWatch();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
